export const productIncentiveTypes = [
	"HELLO_FRESH_COUPON",
	"BOL",
	"COOL_BLUE",
	"TANDONGEVALLEN_VERZEKERING",
	"CASHBACK"
] as string[];
export type ProductIncentiveType = typeof productIncentiveTypes[number];
